export const DIAGNOSTIC_STEP_GET_STARTED_KEY = 'get_started';
export const DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_KEY = 'general_recommendations';
export const DIAGNOSTIC_STEP_PERMISSION_KEY = 'permission';
export const DIAGNOSTIC_STEP_PERMISSION_ERROR_KEY = 'permission_error';
export const DIAGNOSTIC_STEP_VIDEO_KEY = 'video';
export const DIAGNOSTIC_STEP_AUDIO_KEY = 'audio';
export const DIAGNOSTIC_STEP_BROWSER_SUPPORT_KEY = 'browser_support';
export const DIAGNOSTIC_STEP_CONNECTIVITY_KEY = 'connectivity';
export const DIAGNOSTIC_STEP_QUALITY_KEY = 'quality';
export const DIAGNOSTIC_STEP_RESULTS_KEY = 'results';

export const DIAGNOSTIC_STEP_GET_STARTED_VALUE = 0;
export const DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE = 1;
export const DIAGNOSTIC_STEP_PERMISSION_VALUE = 2;
export const DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE = 3;
export const DIAGNOSTIC_STEP_VIDEO_VALUE = 4;
export const DIAGNOSTIC_STEP_AUDIO_VALUE = 5;
export const DIAGNOSTIC_STEP_BROWSER_SUPPORT_VALUE = 6;
export const DIAGNOSTIC_STEP_CONNECTIVITY_VALUE = 7;
export const DIAGNOSTIC_STEP_RESULTS_VALUE = 8;

export const DIAGNOSTICS_STEPS_KEYS = {
  [DIAGNOSTIC_STEP_GET_STARTED_VALUE]: DIAGNOSTIC_STEP_GET_STARTED_KEY,
  [DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE]: DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_KEY,
  [DIAGNOSTIC_STEP_PERMISSION_VALUE]: DIAGNOSTIC_STEP_PERMISSION_KEY,
  [DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE]: DIAGNOSTIC_STEP_PERMISSION_ERROR_KEY,
  [DIAGNOSTIC_STEP_VIDEO_VALUE]: DIAGNOSTIC_STEP_VIDEO_KEY,
  [DIAGNOSTIC_STEP_AUDIO_VALUE]: DIAGNOSTIC_STEP_AUDIO_KEY,
  [DIAGNOSTIC_STEP_BROWSER_SUPPORT_VALUE]: DIAGNOSTIC_STEP_BROWSER_SUPPORT_KEY,
  [DIAGNOSTIC_STEP_CONNECTIVITY_VALUE]: DIAGNOSTIC_STEP_CONNECTIVITY_KEY,
  [DIAGNOSTIC_STEP_RESULTS_VALUE]: DIAGNOSTIC_STEP_RESULTS_KEY,
};

export const DIAGNOSTICS_STEPS_VALUES = Object.fromEntries(
  Object.entries(DIAGNOSTICS_STEPS_KEYS).map(([key, value]) => [value, key])
);

export const DIAGNOSTICS_STEPS_COUNT = Object.keys(DIAGNOSTICS_STEPS_KEYS).length;

export const DIAGNOSTICS_HEADER_LABELS = [
  {
    label: 'general_recommendations',
    value: DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE,
  },
  {
    label: 'device_software_setup',
    value: DIAGNOSTIC_STEP_PERMISSION_VALUE,
  },
  {
    label: 'connectivity',
    value: DIAGNOSTIC_STEP_CONNECTIVITY_VALUE,
  },
  {
    label: 'get_results',
    value: DIAGNOSTIC_STEP_RESULTS_VALUE,
  },
];

export const AUDIO_LEVEL_THRESHOLD = 200;

export const AUDIO_LEVEL_STANDARD_DEVIATION_THRESHOLD = AUDIO_LEVEL_THRESHOLD * 0.05; // 5% threshold

export const INPUT_TEST_DURATION = 20000;

export const RECORD_DURATION = 4000;

export const EXCLUSIVE_STEPS = [
  DIAGNOSTIC_STEP_GET_STARTED_VALUE,
  DIAGNOSTIC_STEP_GENERAL_RECOMMENDATIONS_VALUE,
  DIAGNOSTIC_STEP_RESULTS_VALUE,
];

export const DIAGNOSTICS_MEDIA_SIZES = {
  xs: 576,
  sm: 768,
  md: 950,
  lg: 1120,
};

export const DIAGNOSTICS_MEDIA = {
  xs: `(max-width: ${DIAGNOSTICS_MEDIA_SIZES.xs}px)`,
  sm: `(max-width: ${DIAGNOSTICS_MEDIA_SIZES.sm}px)`,
  md: `(max-width: ${DIAGNOSTICS_MEDIA_SIZES.md}px)`,
  lg: `(max-width: ${DIAGNOSTICS_MEDIA_SIZES.lg}px)`
};
